import { call, put, takeEvery } from 'redux-saga/effects'
// Login Redux States
import { MARKETS_FETCH, UPDATE_FAVORITE, PRICING_FETCH,MARKETS_FETCH_SPECIFIC } from './actionTypes'
import {
  fetchMarketsFailed,
  fetchMarketsSuccessful,
  fetchSpecificMarketFailed,
  fetchSpecificMarketSuccessful,
  updateFevouriteFail,
  updateFevouriteSuccess,
  fetchPricingSuccessful,
  fetchPricingFailed,
} from './actions'

//Include Both Helper File with needed methods
import * as marketsApi from '../../../apis/markets'
import { showErrorNotification, showSuccessNotification } from 'store/actions'

function* fetchMarkets(params) {
  try {
    const data = yield call(marketsApi.fetchMarkets, params)
    
    // Fetch pricing data from HTX first
    let marketsWithPricing = data
    if (data && Array.isArray(data)) {
      try {
        const pricingResponse = yield call(marketsApi.fetchPricingPairs, data)
        
        if (pricingResponse.success && pricingResponse.data) {
          // Merge pricing data with markets data
          marketsWithPricing = data.map((market) => {
            const pricingMatch = pricingResponse.data.find((pricing) => 
              pricing.pairName === market.pairName || 
              pricing.symbol.toLowerCase() === market.pairName?.replace('/', '').toLowerCase()
            )

            if (pricingMatch) {
              return {
                ...market,
                  currentPrice: pricingMatch.currentPrice,
                  percentage: pricingMatch.percentage,
                  isPositive: pricingMatch.isPositive,
                  high24h: pricingMatch.high,
                  low24h: pricingMatch.low,
                  volume24h: pricingMatch.volume,
                  volume: pricingMatch.volume,
                  open: pricingMatch.open,
                  buyPrice: pricingMatch.buyPrice,
                  sellPrice: pricingMatch.sellPrice,
                  lastUpdated: pricingMatch.lastUpdated,
                  close: pricingMatch.currentPrice
                
              }
            }

            return market
          })
          
          // Store pricing data in state
          yield put(fetchMarketsSuccessful(marketsWithPricing))
          // yield put(fetchPricingSuccessful(pricingResponse.data))
        } else {
          yield put(fetchPricingFailed(pricingResponse.error || 'Failed to fetch pricing'))
        }
      } catch (pricingError) {
        console.log('Error fetching pricing:', pricingError)
        yield put(fetchPricingFailed(pricingError.message || 'Failed to fetch pricing data'))
      }
    }
    
    // Dispatch markets successful with pricing data already merged
    yield put(fetchMarketsSuccessful(marketsWithPricing))
  } catch (error) {
    yield put(fetchMarketsFailed(error))
  }
}
function* fetchSpecificMarket(action) {
  try {
    // const pairName = action.payload; 
        const { baseAsset, quoteAsset } = action.payload;
    const data = yield call(marketsApi.fetchSpecificMarket, `${baseAsset}/${quoteAsset}`)
    yield put(fetchSpecificMarketSuccessful(data))
  } catch (error) {
    yield put(fetchSpecificMarketFailed(error))
  }
}

function* fetchPricing(action) {
  try {
    const markets = action.payload
    const pricingResponse = yield call(marketsApi.fetchPricingPairs, markets)
    
    if (pricingResponse.success) {
      yield put(fetchPricingSuccessful(pricingResponse.data))
    } else {
      yield put(fetchPricingFailed(pricingResponse.error))
    }
  } catch (error) {
    console.log('Error fetching pricing:', error)
    yield put(fetchPricingFailed(error.message || 'Failed to fetch pricing data'))
  }
}

function* updateFavourite(params) {
  try {
    const data = yield call(marketsApi.updateFavorite, params)
    yield call(fetchMarkets, {})
    yield put(updateFevouriteSuccess({ data }))
    yield put(showSuccessNotification('Symbols updated successfully.'))
  } catch (error) {
    console.log('Error', error)
    yield put(updateFevouriteFail({ error }))
    // yield put(showErrorNotification(error.message || "Failed to update symbols."));
  }
}
function* marketsSaga() {
  yield takeEvery(MARKETS_FETCH, fetchMarkets)
  yield takeEvery(MARKETS_FETCH_SPECIFIC, fetchSpecificMarket)
  yield takeEvery(UPDATE_FAVORITE, updateFavourite)
  yield takeEvery(PRICING_FETCH, fetchPricing)
}

export default marketsSaga
